export namespace NMarkerIO {

    export const configUrl = 'marker-io'

    export interface IConfig {
        project: string;
    }

    export interface IMarker {
        __cs: any[];
        hide: () => void;
        show: () => void;
    }
}
